var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookURipUvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.375,
    height: 53.126,
    viewBox: "0 0 44.375 53.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.58 -2.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.782,21.34V40.967A1.781,1.781,0,0,1,52,42.747H39.984a3.611,3.611,0,0,1-7.206,0H20.76a1.781,1.781,0,0,1-1.78-1.78V21.34a1.781,1.781,0,0,1,1.78-1.78h.7V37.255A3.054,3.054,0,0,0,24.506,40.3h8.885a4.691,4.691,0,0,0,2.99-1.083A4.691,4.691,0,0,0,39.37,40.3h8.885A3.054,3.054,0,0,0,51.3,37.255V19.56H52a1.781,1.781,0,0,1,1.78,1.781Z",
    transform: "translate(-1.826 -2.754)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.049,15.65H40.163a2.986,2.986,0,0,0-2.99,2.99,2.991,2.991,0,0,0-2.99-2.99H25.3a1.369,1.369,0,0,0-1.369,1.369v19.61A1.369,1.369,0,0,0,25.3,38h8.885a3,3,0,0,0,2.99-2.99A2.991,2.991,0,0,0,40.163,38h8.885a1.369,1.369,0,0,0,1.369-1.369V17.019a1.369,1.369,0,0,0-1.369-1.369ZM33.428,33.975H27.667a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.207H27.667a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.207H27.667a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.208H27.667a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68ZM46.672,33.975H40.911a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.207H40.911a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.207H40.911a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Zm0-4.208H40.911a.84.84,0,1,1,0-1.68h5.761a.84.84,0,1,1,0,1.68Z",
    transform: "translate(-2.619 -2.127)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.58 2.37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.657,11.843V8.156A5.8,5.8,0,0,0,38.871,2.37h-25.5A5.792,5.792,0,0,0,7.58,8.156V49.71A5.792,5.792,0,0,0,13.366,55.5h25.5a5.8,5.8,0,0,0,5.786-5.786V41.673H40.374v5.694H11.855V9.718h28.52v2.125ZM22.78,50.172h6.668a.84.84,0,0,1,0,1.68H22.78a.84.84,0,0,1,0-1.68ZM27.651,7.3H24.578a.84.84,0,1,1,0-1.68h3.074a.84.84,0,1,1,0,1.68Z",
    transform: "translate(-7.58 -2.37)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookURipUvp);
export default __webpack_public_path__ + "static/media/book_URipUVP.969a38063eef6afd5e21870006c1535d.svg";
export { ForwardRef as ReactComponent };